// extracted by mini-css-extract-plugin
module.exports = {"root":"StackedBarChartLayout-module--root--Kgy44","chart":"StackedBarChartLayout-module--chart--3HULt"};